import { render } from "./Page22.vue?vue&type=template&id=3ee26903"
import script from "./Page22.vue?vue&type=script&lang=js"
export * from "./Page22.vue?vue&type=script&lang=js"

import "./Page22.vue?vue&type=style&index=0&id=3ee26903&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__